export const createStoreMock = <T = any>(mockState: T): any => {
  return {
    getState: (): T => mockState,
    subscribe: () => 0,
    dispatch: { type: 'dispatch' },
  };
};
